// extracted by mini-css-extract-plugin
export default {"container":"_d2878851","lazyPlaceholder":"_df9d6f1b","shimmer":"_161fd6b3","shimmerLoadingBackground":"_149b9e5b"};